module.exports = __webpack_public_path__ + "img/card1.851a2d7a.png";